import React, { useState, useEffect } from 'react'

import useJWT from "../../hooks/useJWT";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import useChangePassword from '../../hooks/useChangePassword';

const schema = yup.object({
    newPassword: yup.string().required("Password is required"),
    newConfirmPassword: yup.string().required("Confirm Password is required").oneOf([yup.ref("newPassword"), null], "Passwords must match"),
}).required();

const ChangePassword = ({ }) => {
    const { user } = useJWT();

    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = React.useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        setValue,
        watch,
        reset: resetForm
    } = useForm({
        resolver: yupResolver(schema), defaultValues: {
            newPassword: "",
            newConfirmPassword: "",
        }
    });

    const { changePassword, status, error } = useChangePassword();

    const onSubmit = (dataForm) => {
        const _data = {
            id: user?.id,
            newPassword: dataForm.newPassword,
        };
        //console.log(_data);
        changePassword(_data);
    };

    useEffect(() => {
        if (status === 'done') {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Change Password Successfully",
            });
            resetForm();
        } else if (status === 'error') {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error,
            });
        }
    }, [status]);

    return (
        <section className='p-10'>
            <div className="container container-lg">
                <h6 className="text-xl pb-10 mb-10 d-flex align-items-center gap-12">
                    Change Password
                </h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="password"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    New Password
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={isShowPassword ? 'text' : 'password'}
                                        //type="password"
                                        className="common-input"
                                        {...register("newPassword")}
                                        placeholder="Enter Password"
                                    />
                                    <span
                                        className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                        onClick={() => setIsShowPassword(!isShowPassword)}
                                    />
                                </div>
                                {errors.newPassword && (
                                    <p className="text-danger mt-2">{errors.newPassword.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="password"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Confirm Password
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={isShowConfirmPassword ? 'text' : 'password'}
                                        className="common-input"
                                        {...register("newConfirmPassword")}
                                        placeholder="Enter Confirm Password"
                                    />
                                    <span
                                        className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowConfirmPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                        onClick={() => setIsShowConfirmPassword(!isShowConfirmPassword)}
                                    />
                                </div>
                                {errors.newConfirmPassword && (
                                    <p className="text-danger mt-2">
                                        {errors.newConfirmPassword.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <button type="submit" className="btn bg-main-one-600 text-white px-64 mt-24">{status === "loading" ? "Loading..." : "Change Password"}</button>
                </form>

            </div>
        </section>
    )
}

export default ChangePassword